import { Info } from 'lucide-react';
import { notaDeAyuda } from '../ayudas/notas';

// =====================================================================
// LA AYUDA ES UN DATO, NO UNA CADENA SUELTA EN UNA PANTALLA
// =====================================================================
// Cada nota vive en `src/ayudas/catalogo.json` con su `id`, su ancla
// (pantalla + control), su capa, su version y su fecha. Aqui solo se
// dice CUAL se pinta.
//
// POR QUE, Y NO ES BUROCRACIA. Antes de esto, la misma regla —«el codigo
// no se puede cambiar»— vivia dentro de un parrafo de la pantalla de
// Ubicaciones, a ocho lineas del campo que la ejecuta. Nadie que
// estuviera escribiendo el codigo la leia, porque estaba arriba del
// todo. Con la ayuda como dato, la regla tiene un ancla y se puede
// comprobar que sigue existiendo, que no pasa del presupuesto de su capa
// y que no confiesa nada — cosas que un parrafo suelto no permite.

// LAS TRES CAPAS, Y CADA UNA SE PINTA DISTINTA A PROPOSITO.
//
//   1 · pantalla · que es esto y para que sirve. Sin reglas.
//   2 · el control · la regla dura, pegada al campo o boton que la aplica.
//   3 · la ficha ·  definiciones y formulas, con version y fecha.
const PINTA = {
  1: 'flex gap-2 rounded-xl border p-3 text-sm leading-relaxed '
     + 'bg-[var(--color-marca-suave)] border-[var(--color-marca-borde)] '
     + 'text-[var(--color-marca-oscura)]',
  2: 'block text-xs text-gray-600 mt-1 leading-relaxed',
  3: 'block text-xs text-gray-500 leading-relaxed',
};

/**
 * Pinta una nota del catalogo.
 *
 * NO ADMITE TEXTO LITERAL. Si alguien escribe `<Ayuda id="x">texto</Ayuda>`
 * se lanza: ese texto no tendria ancla, ni version, ni fecha, y ninguna
 * de las pruebas de la norma podria verlo. Es el agujero por el que
 * volveria a entrar todo lo que esta fase acaba de sacar.
 */
export default function Ayuda({ id, children }) {
  if (children !== undefined) {
    throw new Error(
      `<Ayuda id="${id}"> no admite texto escrito dentro. La ayuda vive en `
      + 'src/ayudas/catalogo.json, con su ancla y su version. Añádela ahí y '
      + 'refiérela por su id.');
  }

  const nota = notaDeAyuda(id);
  if (!nota) {
    // EN DESARROLLO SE GRITA; EN PRODUCCION NO SE PINTA UN HUECO RARO.
    // Una ayuda que falta es un fallo de quien la escribio, no algo que
    // el usuario tenga que ver.
    if (import.meta.env?.DEV) {
      throw new Error(`No hay ninguna ayuda con id «${id}» en el catálogo.`);
    }
    return null;
  }

  if (nota.capa === 1) {
    return (
      <div className={PINTA[1]}>
        <Info className="h-4 w-4 mt-0.5 shrink-0" aria-hidden="true" />
        <div>{nota.texto}</div>
      </div>
    );
  }
  return <span className={PINTA[nota.capa]}>{nota.texto}</span>;
}

